"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _utils = require("../../utils");
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function Overlay(_ref) {
  let {
    backgroundColor,
    zIndex
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    backgroundColor: backgroundColor,
    zIndex: zIndex
  });
}
const Wrapper = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: ", ";\n\n  background-color: ", ";\n"])), _ref2 => {
  let {
    zIndex
  } = _ref2;
  return zIndex;
}, _ref3 => {
  let {
    backgroundColor
  } = _ref3;
  return (0, _utils.hexToRGBA)(backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : '#000000', 0.95);
});
var _default = exports.default = Overlay;